import { render, staticRenderFns } from "./ClienteNovosMovimentacaoAnual.vue?vue&type=template&id=788d1ed7&scoped=true&"
import script from "./ClienteNovosMovimentacaoAnual.vue?vue&type=script&lang=js&"
export * from "./ClienteNovosMovimentacaoAnual.vue?vue&type=script&lang=js&"
import style0 from "./ClienteNovosMovimentacaoAnual.vue?vue&type=style&index=0&id=788d1ed7&scoped=true&lang=css&"
import style1 from "./ClienteNovosMovimentacaoAnual.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788d1ed7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
